/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { useContext, useState } from 'react';
import MetricsContext from './MetricsContext';
import commands from './commands';
import { css, jsx } from '@emotion/core';

export default (): null | Element<string> => {
  const tips = ['You can drag to re-order these widgets.'];
  const [tipIndex, setTipIndex] = useState(0);
  const item = tips[tipIndex];
  const nextTip = () =>
    setTipIndex((v) => (v + 1 > tips.length - 1 ? 0 : v + 1));
  const ctx = useContext(MetricsContext);
  if (ctx.state.tipsDismissed) return null;
  const dismissTips = () => commands(ctx).tipsDismissed();
  const showCounter = tips.length > 1;
  const NextButton = () => (
    <button onClick={nextTip} css={css('padding: 0; margin-left: 10px;')}>
      Next <i className="fa fa-caret-right" />
    </button>
  );
  const CounterRow = () =>
    showCounter ? (
      <div css={css('padding-top: 5px;')}>
        ({tipIndex + 1} / {tips.length}) <NextButton />
      </div>
    ) : null;

  return (
    <div
      css={css(`
      display: grid;
      grid-template-columns: 1fr 35px;
      grid-gap: 20px;
      font-size: 1rem;
      border-bottom: solid 1px #999;
      background: #333;
      color: white;
      padding: 5px 0 5px 10px;
      align-items: center;
    `)}
    >
      <div>
        <div css={css('line-height: 1.6rem;')}>Tip: {item}</div>
        <CounterRow />
      </div>
      <div css={css('button {color: white;}')}>
        <button onClick={dismissTips}>
          <i className="fa fa-times" />
        </button>
      </div>
    </div>
  );
};
